import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #F5F5F5;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const MenuList = styled.div`
  background: white;
  margin-top: 20px;
`;

export const MenuItem = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #F5F5F5;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s;
  opacity: ${({ disabled }) => disabled ? 0.4 : 1};

  &:hover {
    background-color: ${({ disabled }) => disabled ? 'transparent' : '#FAFAFA'};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const MenuIcon = styled.div`
  font-size: 20px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  color: #666;
`;

export const MenuText = styled.div`
  font-size: 16px;
  color: #333;
  font-weight: 500;
`;
